import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(robot)/robot/[id]/robotClientComponent.tsx");
